<template>
    <div>
        <component
            :is="$mapaTelas(tela.tipo)"
            v-if="!remontar"
            @voltar="voltar"
            @cancelar="cancelar"
            @processar="processar"
            :servicoAtendimento="servicoAtendimento"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "tela",
    props: {
        servicoAtendimento: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            remontar: false,
        };
    },
    computed: {
        tela() {
            return this.servicoAtendimento.telaAtual();
        },
        ...mapGetters("contexto", ["contexto"]),
    },
    methods: {
        forcarRemontagem() {
            this.remontar = true;
            this.$nextTick(() => {
                this.remontar = false;
            });
        },
        async processar(dados) {
            await this.servicoAtendimento.processarTela(dados);
            this.forcarRemontagem();
        },
        voltar() {
            this.servicoAtendimento.voltar();
            this.forcarRemontagem();
        },
        cancelar() {
            this.servicoAtendimento.cancelar();
        },
    },
};
</script>
